import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
  erroAlert: {
    width: '',
    color: `${theme.palette.primary.contrastText} !important`,
    backgroundColor: `${theme.palette.error.main} !important`,
    fontFamily: 'Nunito !important',
    fontSize: '14px !important',
    fontWeight: '600 !important',
    lineHeight: '20px !important',

    '& .MuiSvgIcon-root': {
      color: `${theme.palette.primary.contrastText} !important`,
    },
  },
}))

export { useStyles }
